import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FIELD_TYPES } from '../../../../common/globals';
import DescriptionEditor from '../../FormDetails/DescriptionEditor';

class MultipleChoiceElementDetails extends PureComponent {
  handleMultipleChoiceToggle = (ev) => {
    const {
      checked
    } = ev.target;
    
    const { onFormElementTypeChange } = this.props;

    if (checked) {
      onFormElementTypeChange(FIELD_TYPES.CHECKBOXES);
    }
    else {
      onFormElementTypeChange(FIELD_TYPES.SELECT);
    }
  };

  handleOnChange = (ev) => {
    const { name, value } = ev.target;
    const {
      element,
      onFormElementChange
    } = this.props;

    let payload = {
      name,
      value
    };

    if (name === 'default' && element.type === 'array') {
      payload = {
        name,
        value: [value]
      };
    }

    onFormElementChange(payload);
  };

  handleOptionsChange = (ev) => {
    const { value: optionsText } = ev.target;
    const { onFormElementOptionsChange } = this.props;

    onFormElementOptionsChange(optionsText);
  }

  handleRequiredChange = () => {
    const {
      element,
      onFormElementRequiredChange
    } = this.props;

    onFormElementRequiredChange(element.id);
  };

  handleMoveUp = () => {
    const {
      element,
      onMoveUp
    } = this.props;

    const { id } = element;
    onMoveUp(id);
  };

  handleMoveDown = () => {
    const {
      element,
      onMoveDown
    } = this.props;

    const { id } = element;
    onMoveDown(id);
  };

  getOptions = (element) => {
    let options = [];

    if (element.type === 'string') {
      options = element.enum;
    }
    else {
      options = element.items.enum;
    }

    return options;
  };

  render() {
    const {
      element,
      onFormElementChange
    } = this.props;
    
    const {
      type,
      title,
      description,
      default: defaultValue,
      required
    } = element;

    const options = this.getOptions(element);
    const optionsValue = _.join(options, '\n');
    const optionsElements = _.map(options, option => (
      <option
        key={option}
        value={option}
      >
        {option}
      </option>
    ));

    const isMultipleChoice = type === 'array';

    let elementDefault = '';
    if (!_.isUndefined(defaultValue)) {
      if (_.isArray(defaultValue)) {
        [elementDefault] = defaultValue;
      }
      else {
        elementDefault = defaultValue;
      }
    }

    return (
      <div>
        <div className="form-group">
          <label htmlFor="title">
            Title
          </label>
          <input
            id="title"
            type="text"
            name="title"
            className="form-control"
            value={title}
            onChange={this.handleOnChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="description">
            Description
          </label>
          <DescriptionEditor
            markdown={description || ''}
            onMarkdownChange={md => onFormElementChange({ name: 'description', value: md })}
          />
        </div>
        <div className="form-group">
          <label htmlFor="enum">
            Options
          </label>
          <p className="field-description">
            Enter one option per line
          </p>
          <textarea
            className="form-control"
            id="enum"
            type="textarea"
            name="enum"
            value={optionsValue}
            onChange={this.handleOptionsChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="default">
            Default value
          </label>
          <select
            id="default"
            name="default"
            className="form-control"
            value={elementDefault}
            onChange={this.handleOnChange}
          >
            {optionsElements}
          </select>
        </div>
        <div className="form-group checkbox">
          <label htmlFor="required">
            <input
              id="required"
              type="checkbox"
              checked={required}
              onChange={this.handleRequiredChange}
            />
            <span className="cr">
              <i className="cr-icon glyphicon glyphicon-ok" />
            </span>
            Required
          </label>
        </div>
        <div className="form-group checkbox">
          <label htmlFor="isMultipleChoice">
            <input
              id="isMultipleChoice"
              type="checkbox"
              name="isMultipleChoice"
              checked={isMultipleChoice}
              onChange={this.handleMultipleChoiceToggle}
            />
            <span className="cr">
              <i className="cr-icon glyphicon glyphicon-ok" />
            </span>
            Allow to select more than one option
          </label>
        </div>
        <div className="form-group">
          <label>
            Position
          </label>
          <div className="move-buttons-container">
            <button
              type="button"
              className="btn btn-default"
              onClick={this.handleMoveUp}
            >
              Move up
            </button>
            &nbsp;
            <button
              type="button"
              className="btn btn-default"
              onClick={this.handleMoveDown}
            >
              Move down
            </button>
          </div>
        </div>
      </div>
    );
  }
}

MultipleChoiceElementDetails.propTypes = {
  element: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    default: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
    required: PropTypes.bool,
    format: PropTypes.string,
    enum: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  onFormElementChange: PropTypes.func.isRequired,
  onFormElementTypeChange: PropTypes.func.isRequired,
  onFormElementRequiredChange: PropTypes.func.isRequired,
  onFormElementOptionsChange: PropTypes.func.isRequired,
  onMoveUp: PropTypes.func.isRequired,
  onMoveDown: PropTypes.func.isRequired
};

export default MultipleChoiceElementDetails;
